import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import _ from 'lodash';

import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { getItem } from 'src/reducers/common/itemReducer';
import selector, { numberWithComma, display } from 'src/utils/Utils';
import { Section } from 'jbc-front/components/Form';
import tableStyles from '../styles/GeneralTableInfo.scss';

const PaymentItem = ({ item, employeeBanks }) => {
  const { t } = useTranslation();

  const getEmployeeBankLabel = bankId => {
    const index = _.findIndex(employeeBanks, { id: bankId });
    if (index === -1) {
      return '';
    }
    return `${t('features.Employees.showEmployee.bank_account_information')}${index + 1}`;
  };

  return (
    <div>
      <Section title={item.label}>
        <table className={tableStyles.mTablePersonal}>
          <tbody>
            <tr>
              <th>{t('features.ClientBonusAllowances.components.BonusAllowancesTable.amount')}：</th>
              <td>
                {item.transferType}{' '}
                {item.transferType === t('features.Employees.components.PaymentBankItemSection.fixed_amount') &&
                  `：${numberWithComma(item.fixedAmount)}B`}
              </td>
            </tr>
            {item.paymentOrder !== 'fourth' && (
              <React.Fragment>
                <tr>
                  <th>{t('features.ClientBonusAllowances.components.BonusAllowancesTable.receiver')}：</th>
                  <th>{display(item.employeeBankId && getEmployeeBankLabel(item.employeeBankId))}</th>
                </tr>
                <tr>
                  <th>{t('features.ClientBonusAllowances.components.BonusAllowancesTable.transfer_source')}：</th>
                  <th>{item.clientBankName}</th>
                </tr>
              </React.Fragment>
            )}
          </tbody>
        </table>
      </Section>
    </div>
  );
};

const mapStateToProps = state => ({
  employeeBanks: selector(getItem(REDUCER_NAME, state), 'employeeBanks') || []
});

export default connect(mapStateToProps)(PaymentItem);
